export const PRINCIPAL_STATES = {
  ACTIVE: 1,
  INVITED: 2,
  DISABLED: 3,
  LOCKEDOUT: 4,
  DELETED: 5,
  PASSWORDTORESET: 6,
  PENDING: 7,
};

export const ORGANISATION_STATES = {
  ACTIVE: 1,
  UNLISTED: 2,
  INACTIVE: 3,
  DELETED: 4,
  PENDING: 5,
};
